import React from 'react'
import docStyle from './Document.module.css'
import { Box, Button, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import IconButton from '@mui/material/IconButton';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { useState } from 'react';
import axios from 'axios';
import { useEffect } from 'react';

// import this for redux read write
import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'
import { useParams } from 'react-router-dom';
import useBackdrop from '../../hooks/useBackdrop/useBackdrop';
import useToast from '../../hooks/useToast';
import DeleteConformation from '../DeleteConformation/DeleteConformation';


const Document = () => {
    const { invId, channelId } = useParams();

    // get data from redux
    const name = useSelector((state) => state.globalData.name);
    const count = useSelector((state) => state.globalData.notificationCount);
    const dispatch = useDispatch()
    const [tempData, setTempData] = useState(null);
    const { Toast, showToast } = useToast();
    const { openBackdrop, closeBackdrop, BackdropComponent } = useBackdrop();


    const [data, setData] = useState([])

    const getAllDocumentsData = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_COSMOSINV}/channel/getChannelById/${channelId}`
            )
            setData(res.data)
            console.log(res.data)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getAllDocumentsData()
    }, [])

    const deleteDocuments = async () => {
        try {
            const res = await axios.delete(
                `${process.env.REACT_APP_COSMOSINV}/documents/deleteById/${invId}/${channelId}/${tempData.documentId}`
            ).then((res) => {
                showToast("success", "Document  Delete Successfully");
                handleDeleteModal();
                getAllDocumentsData();
            })

            dispatch(setNotificationCount({
                count: count + 1,
            }))

        } catch (error) {
            console.log(error)
        }
    }




    const [deleteModal, setDeleteModal] = useState(false);

    const handleDeleteModal = (data) => {
        setDeleteModal(prev => !prev)
        if (data !== undefined && data !== "" && data !== null) {
            setTempData(data)
        }
    }



    return (
        <>
            <Toast />
            <BackdropComponent />
            <div className={docStyle.companyDetailsMain}>
                <div className={docStyle.companyDetailsContent}>
                    <div className={docStyle.companyDetailsHeader}>
                        <Typography sx={{ marginTop: '1%', color: '#121926', fontWeight: '600', fontSize: '20px' }} >
                            Investor Opportunities
                        </Typography>
                        <Link to={`create`}>
                            <Button sx={{ textTransform: 'capitalize' }} variant='contained'>Add</Button>
                        </Link>
                    </div>
                    <Box className={docStyle.companyDetailsComponent}>
                        <div className={docStyle.companyDetailsComponentLeft}>
                            <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                Name
                            </Typography>
                        </div>
                        <div className={docStyle.companyDetailsComponentRight}>
                            <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                Last modified
                            </Typography>
                            <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                Action
                            </Typography>
                        </div>
                    </Box>
                    {data.docs?.map((doc) =>
                        <Box className={docStyle.companyDetailsComponent}>
                            <div className={docStyle.companyDetailsComponentLeft}>
                                <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                    {doc.documentName}
                                </Typography>
                            </div>
                            <div className={docStyle.companyDetailsComponentRight}>
                                <Typography variant='h6' sx={{ fontSize: '15px' }}>
                                    {doc.date}
                                </Typography>
                                <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600', display: 'flex', alignItems: 'baseline' }}>
                                    {/* <Link to={`/EditInvOppo/${doc?.invId}`} > */}
                                    <Link to={`${doc?.documentId}`} state={{ graphInfo: doc }} >
                                        {/* <Link to= '/EditInvOppo'> */}
                                        <BorderColorOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
                                    </Link>
                                    <IconButton disableRipple onClick={() => handleDeleteModal(doc)}>
                                        <DeleteForeverOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer', marginLeft: '10px' }} />
                                    </IconButton>
                                </Typography>
                            </div>
                        </Box>
                    ).reverse()}
                </div>
            </div>


            <DeleteConformation
                onClose={handleDeleteModal}
                open={deleteModal}
                onConfirm={() => deleteDocuments()}
                onReject={() => { }}
            >
                <h2>Delete Document</h2>
                <p>Are you sure you want to Delete this Document?</p>

            </DeleteConformation>
        </>
    )
}

export default Document





